import Cookies from 'js-cookie'
import { getParams } from '@/utils'

export const dialogConfH5 = {
  class: 'dialog-h5',
  closable: false,
  actionClass: 'dialog-h5__action',
  negativeButtonProps: {
    text: true,
    block: true,
    style: `--n-text-color: #666;
--n-text-color-hover: #666;
--n-text-color-pressed: #666;
--n-text-color-focus: #666;`
  },
  positiveButtonProps: {
    text: true,
    block: true,
    type: 'primary'
  }
}

export function isH5Page() {
  return location.hash.indexOf('#/h5/') === 0
}

export const getChannelExtend = () => {
  const egretSoftChannel = Cookies.get('egret-soft-channel')
  const extend = getParams('extend')
  const EXTEND_PARAMS = {
    ...(egretSoftChannel ? JSON.parse(decodeURIComponent(egretSoftChannel)) : {}),
    ...(extend ? JSON.parse(extend) : {})
  }
  return JSON.stringify(EXTEND_PARAMS)
}

//设置必应增强转化代码
export const setBingPid = ({ em, ph }) => {
  // Add this script right after your base UET tag code
  window.uetq = window.uetq || []
  window.uetq.push('set', {
    pid: {
      em, // Replace with the variable that holds the user's email address.
      ph // Replace with the variable that holds the user's phone number.
    }
  })
  uet_report_conversion('注册')
}

//用与转化相关的真实收入值来更新revenue_value参数 可变的真实收入 注册和表单没有 默认为0
const Replace_with_Variable_Revenue_Function = () => {
  return 0
}

//安装事件标签 注册、表单提交 Replace_with_Variable_Revenue_Function 返回变量数据
function uet_report_conversion(event = '注册') {
  window.uetq = window.uetq || []
  window.uetq.push('event', '注册', {
    revenue_value: Replace_with_Variable_Revenue_Function(),
    currency: 'CNY'
  })
  // window.uetq.push('event', '提交表单', { revenue_value: Replace_with_Variable_Revenue_Function(), currency: 'CNY' });
}

/** 租户语种过滤 - 根据租户允许的语种编码过滤基础选项 */
export function buildTenantLocaleSwitcherOptions(
  baseOptions: {value: string; label: string}[],
  apiLocaleCodes: string[]
): {value: string; label: string}[] {
  if (!apiLocaleCodes?.length) return baseOptions
  const allow = new Set(apiLocaleCodes)
  const result = baseOptions.filter(option => allow.has(option.value))
  return result.length > 0 ? result : baseOptions
}
